import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";
import { VERIFY_REGISTERED_EMAIL } from "@/hooks";

export function useSendVerificationEmail(
  onCompleted?: (data: any) => void,
  onError?: (error: any) => void,
) {
  const [sendVerification, { loading }] = useMutation<any>(
    VERIFY_REGISTERED_EMAIL,
    {
      onCompleted: (res) => {
        const result =
          res?.verifyRegisteredEmail || res?.comVerifyRegisteredEmail;
        if (result?.success) {
          onCompleted?.(res);
        } else {
          onError?.(result?.message || "Failed to send verification email");
        }
      },
      onError: (err) => {
        onError?.(err?.message || "Failed to send verification email");
      },
    },
  );

  const sendEmail = useCallback(
    (email: string, host?: string, lang?: string) => {
      return sendVerification({
        variables: {
          email,
          host: host || window.location.origin,
          lang,
        },
      });
    },
    [sendVerification],
  );

  return { sendEmail, loading };
}
